<template>
  <v-container fluid>
    <v-row>
      <v-radio-group v-model="value" row>
        <v-radio label="Please write a short personal statement" value="write"></v-radio>
        <v-radio label="Upload motivation letter" class="ml-4" value="upload"></v-radio>
      </v-radio-group>
    </v-row>
    <v-row v-if="writeLetter">
      <v-textarea
        @change="motivationLetterTextChanged"
        v-model="motivationLetterText"
        :error-messages="motivationLetterTextErrors"
        no-resize
        counter
        outlined
        full-width
        rows="8"
        :loading="savingMotivationLetter"
      ></v-textarea>
    </v-row>
    <v-row v-else>
      <v-file-input
        v-if="!motivationLetterFileId"
        accept="application/pdf, application/msword"
        prepend-icon="mdi-file-upload-outline"
        :loading="uploadingFile"
        @change="onFileChanged($event,'motivationLetterFileId','motivationLetter')"
        :error-messages="motivationLetterFileErrors"
      />
      <v-text-field
        v-else
        clear-icon="mdi-trash-can-outline"
        append-outer-icon="mdi-open-in-new"
        @click:append-outer="onFileOpen('motivationLetter')"
        @click:clear="onFileCleared('motivationLetterFileId','motivationLetter')"
        :value="motivationLetterFileName"       
        readonly
        clearable
      />
    </v-row>
  </v-container>
</template>

<script>
import submissionMixin from "../mixins/submission.mixin";
import { mapFields } from "vuex-map-fields";
import { requiredIf, minLength } from "vuelidate/lib/validators";

export default {
  name: "MotivationLetter",
  created() {
    this.value =
      this.motivationLetterFileId && this.motivationLetterFileId.length
        ? "upload"
        : "write";
  },
  data() {
    return {
      value: "",
      savingMotivationLetter: false
    };
  },
  mixins: [submissionMixin],
  computed: {
    ...mapFields("profile", {
      motivationLetterText: "profile.motivationLetterText",
      motivationLetterFileId: "profile.motivationLetterFileId",
      motivationLetter: "profile.motivationLetter",
      motivationLetterFileName: "profile.motivationLetter.originalName"
    }),
    writeLetter() {
      return this.value === "write";
    },
    motivationLetterFileErrors() {
      const errors = [];
      if (!this.$v.motivationLetterFileName.$dirty) return errors;
      !this.$v.motivationLetterFileName.required &&
        errors.push("Your Motiviation Letter file is required");
      return errors;
    },
    motivationLetterTextErrors() {
      const errors = [];
      if (!this.$v.motivationLetterText.$dirty) return errors;
      !this.$v.motivationLetterText.required &&
        errors.push("Your Motiviation Letter is required");
      !this.$v.motivationLetterText.minLength &&
        errors.push("Motivation letter must be at least 250 characters long");
      return errors;
    }
  },
  validations: {
    motivationLetterFileName: {
      required: requiredIf(function(form) {
        // the field will be required only if the
        // user selected the upload file option
        console.log(form);
        return this.value === "upload";
      })
    },
    motivationLetterText: {
      required: requiredIf(function(form) {
        // the field will be required only if the
        // user selected the write motiviation letter option
        console.log(form);
        return this.value === "write";
      }),
      minLength: minLength(250)
    }
  },
  methods: {
    async motivationLetterTextChanged(value) {
      this.savingMotivationLetter = true;

      try {
        await this.updateProfileField({
          fieldName: "motivationLetterText",
          fieldValue: value
        });
      } finally {
        this.savingMotivationLetter = false;
      }
    },
    validateForm() {
      // perform form validation
      this.$v.$touch();

      // return validation result (true/false)
      return !this.$v.$invalid;
    }
  }
};
</script>